export default __webpack_public_path__ + "static/media/css.d3964f26.png";